module.exports = __webpack_public_path__ + "static/media/ai.ad3027a5.png";